import getHeadConfig from './getHeadConfig';

export default (state) => getHeadConfig(state).clientRequest;
